/**
 * Centered page container with responsive vertical padding.
 */
export default function PageShell({ children, className = "" }) {
  return (
    <div className={`mx-auto w-full max-w-3xl px-4 py-10 sm:py-16 ${className}`}>
      {children}
    </div>
  );
}
